import i18n from "i18next";
import { economyTranslations } from "./translation/economyTranslations";
import { initReactI18next } from "react-i18next";
import { en } from "./translation/en";
import { no } from "./translation/no";
import { sv } from "./translation/sv";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
// Supported languages, labels and locale aliases: src/app/i18n/languages.js
const resources = {
  en: { ...en, translation: { ...en.translation, economy: economyTranslations.en } },
  nb: { ...no, translation: { ...no.translation, economy: economyTranslations.nb } }, // Bokmål UI strings live in ./translation/no.js (legacy filename)
  no: { ...no, translation: { ...no.translation, economy: economyTranslations.nb } }, // alias for stored settings / deep links
  se: { ...sv, translation: { ...sv.translation, economy: economyTranslations.sv } },
  sv: { ...sv, translation: { ...sv.translation, economy: economyTranslations.sv } },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "nb",
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    // Polish users understand English better than Norwegian if a key is ever missing.
    fallbackLng: { pl: ["en", "nb"], default: ["nb", "no", "en"] },

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// Polish ships as its own chunk (~1 MB of strings) and is only downloaded for
// users who pick Polish or are offered it in the "Ny funksjon" dialog.
const lazyLanguages = {
  pl: () => import("./translation/pl").then((module) => module.pl),
};

/** Make sure a language's strings are registered before `changeLanguage` / `getFixedT`. */
export async function ensureLanguageLoaded(code) {
  const load = lazyLanguages[code];
  if (!load || i18n.hasResourceBundle(code, "translation")) return;
  const bundle = await load();
  i18n.addResourceBundle(code, "translation", { ...bundle.translation, economy: economyTranslations.pl }, true, true);
}

export default i18n;
